const type = {
    // account_enterprise
    SET_ENTERPRISE_NAV_MENU: 'SET_ENTERPRISE_NAV_MENU',
    SET_ENTERPRISE_EMPLOYEE: 'SET_ENTERPRISE_EMPLOYEE',


    // factory_product
    SET_PRODUCT_NAME: 'SET_PRODUCT_NAME',
    SET_NOTIFY_CONNECT: 'SET_NOTIFY_CONNECT',

}
export default type




